import React, { memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import HeaderColumn from '../header-column/HeaderColumn';
import CommonPopper from '../../../components/common-popper/CommonPopper';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import SonarMenu from './SonarMenu';
import { getSonarProjectName } from '../../../redux/sonar/sonarActions';
import SonarDatePicker from './date-picker/SonarDatePicker';

import scss from './SonarDashboardHeader.module.scss';

const SonarDashboardHeader = () => {
  const { t } = useTranslation('header');
  const { id } = useParams();

  const [projectName, setProjectName] = useState('');

  const getProjectName = useCallback(async () => {
    const sonarProjectName = await getSonarProjectName(id);
    setProjectName(sonarProjectName);
  }, [id]);

  useEffect(() => {
    getProjectName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderColumn>
        <div className={scss.menuWrapper}>
          <div className={scss.label}>{t('project')}:</div>

          {projectName ? (
            <CommonPopper placement='bottom-start' component={SonarMenu} isShowCaret>
              <div className={scss.nameWrapper}>
                <Icon icon={ICONS.Sonar} disableCommonColors className={scss.logo} />
                <span className={scss.title}>{projectName}</span>
              </div>
            </CommonPopper>
          ) : null}
        </div>
      </HeaderColumn>

      <HeaderColumn>
        <SonarDatePicker />
      </HeaderColumn>
    </>
  );
};

export default memo(SonarDashboardHeader);
